export default {
  FEEDBACK_BUTTON_REQUEST_SUBMITTED: 'FEEDBACK_BUTTON_REQUEST_SUBMITTED',
  FEEDBACK_BUTTON_REQUEST_COMPLETED: 'FEEDBACK_BUTTON_REQUEST_COMPLETED',
};